import store from '@/store'

export default [
  {
    path: '/academic-years',
    name: 'academic-year',
    meta: { requiresAuth: true },
    component: () => import('@/pages/academic-year/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('academicYear/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/academic-years/:id',
    name: 'academic-year-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/academic-year/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('academicYear/dataBeforeCreate')
      await store.dispatch('academicYear/find', to.params.id)
      next()
    }
  }
]
